import waitForChangeAndMutate from '@utils/user/waitForChangeAndMutate'

const waitForWalletChangeAndMutate = (props) =>
    waitForChangeAndMutate({ ...props, query: 'wallet' })

export default waitForWalletChangeAndMutate